import {StoreRepository} from '../repository/StoreRepository';

export class DeleteStoreUseCase {
  constructor (private storeRepository: StoreRepository) {}

  async execute (id: string): Promise<void> {
    return this.storeRepository.delete(id);
  }
}
